import produce from "immer";
import { createAction, createReducer } from "redux-act";
import { reducerRegistry } from "../reducerRegistry";
import { LayersConfig, LayerSnappingConfig, SnappingState } from "./types";

export const reducerName = "snapping";

const initialState: SnappingState = {
  enabled: true,
  layerFeaturesSnapping: true,
  layersConfig: {},
  showSnappingPoint: true,
  showLayerName: true,
  snappingDistance: 10,
};

export type SnappingLayerConfigUpdate = {
  name: string;
} & Partial<LayerSnappingConfig>;

export const setSnappingEnabled = createAction<boolean>("snapping/set-enabled");
export const setShowSnappingPoint = createAction<boolean>("snapping/set-show-point");
export const setShowLayerName = createAction<boolean>("snapping/set-show-layer-name");
export const setLayerFeaturesSnapping = createAction<boolean>("snapping/set-layer-features-snapping");
export const setSnappingDistance = createAction<number>("snapping/set-distance");
export const setLayersConfig = createAction<LayersConfig>("snapping/set-layers-config");
export const updateLayerConfig = createAction<SnappingLayerConfigUpdate>("snapping/update-layer-config");
export const reducer = createReducer({}, initialState);

reducer.on(
  setSnappingEnabled,
  produce((snappingState: SnappingState, enabled: boolean) => {
    snappingState.enabled = enabled;
  }),
);

reducer.on(
  setShowSnappingPoint,
  produce((snappingState: SnappingState, showSnappingPoint: boolean) => {
    snappingState.showSnappingPoint = showSnappingPoint;
  }),
);

reducer.on(
  setShowLayerName,
  produce((snappingState: SnappingState, showLayerName: boolean) => {
    snappingState.showLayerName = showLayerName;
  }),
);

reducer.on(
  setLayerFeaturesSnapping,
  produce((snappingState: SnappingState, layerFeaturesSnapping: boolean) => {
    snappingState.layerFeaturesSnapping = layerFeaturesSnapping;
  }),
);

reducer.on(
  setSnappingDistance,
  produce((snappingState: SnappingState, snappingDistance: number) => {
    snappingState.snappingDistance = snappingDistance;
  }),
);

reducer.on(
  setLayersConfig,
  produce((snappingState: SnappingState, layersConfig: LayersConfig) => {
    snappingState.layersConfig = layersConfig;
  }),
);

reducer.on(
  updateLayerConfig,
  produce((snappingState: SnappingState, { name, ...snappingConfig }: SnappingLayerConfigUpdate) => {
    const configItem = snappingState.layersConfig[name];

    snappingState.layersConfig[name] = {
      ...configItem,
      ...snappingConfig,
    };
  }),
);

reducerRegistry.register(reducerName, reducer);
